import axios from "axios";
import {getOidcState} from "../security/OidcManager";


axios.interceptors.request.use(function (config) {
        const token = getOidcState().access_token;
        config.headers.Authorization = "Bearer " + token;
        const id_token = getOidcState().id_token;

        if (getOidcState().is_authenticated){
            config.headers.OID = id_token.sub;
            config.headers.LOGIN = id_token.username;
        }
        return config;
    });

    // Response interceptor to handle errors
    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            const status = error?.response?.status;
            const url = error?.config?.url || '';
            if (!status) {
                return Promise.reject(error);
            }

            if (status === 401 || status === 403) {
                //history.navigate('/v2/errorAuthorization');
                history.navigate('/errorAuthorization', { state: { from: window.location.pathname } });
                return Promise.reject(error);
            } else if (status === 404) {
                // Para polling de estado de compra no forzamos navegación global.
                if (url.includes('/carrito/estado-compra/')) {
                    return Promise.reject(error);
                }
                history.navigate('/errorNotFound');
                return Promise.reject(error);
            } else if (status === 502) {
                history.navigate('/errorBackend');
                return Promise.reject(error);
            } else {
                return Promise.reject(error);
            }
        }
    );

    const http = {
        get: axios.get,
        post: axios.post,
        put: axios.put,
        delete: axios.delete,
        patch: axios.patch
    };
    export default http;

    export const history = {
        navigate: null,
        location: null
    };